import React from 'react';
import { Instagram } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { WhatsAppButton } from './ui/WhatsAppButton';
export function Footer() {
  return <footer className="bg-brand-dark relative border-t border-brand-red/20" data-id="element-21">
      {/* Top CTA Section */}
      <div className="py-12 border-b border-white/5" data-id="element-22">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-23">
          <FadeIn data-id="element-24">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-25">
              Reservá tu <span className="text-brand-red" data-id="element-26">Turno</span>
            </h2>
            <p className="text-xl text-brand-silver mb-2" data-id="element-27">
              ¿Querés que tu vehículo vuelva a lucir impecable?
            </p>
            <p className="text-lg text-brand-muted mb-10" data-id="element-28">
              Nuestro equipo está listo para ayudarte.
            </p>

            <WhatsAppButton className="w-full sm:w-auto" data-id="element-29">
              Solicitar turno ahora
            </WhatsAppButton>
          </FadeIn>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="py-12" data-id="element-30">
        <div className="container mx-auto px-4 md:px-6" data-id="element-31">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-32">
            {/* Logo & Tagline */}
            <div className="flex flex-col items-center md:items-start gap-4" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/cGsijbewZbY9eY5pg7NgLx/638335839_17957120598063615_1226353128362342251_n.png" alt="Morello Detailing Logo" className="h-24 w-auto object-contain" data-id="element-34" />
              <p className="font-heading tracking-widest text-brand-silver uppercase text-sm" data-id="element-35">
                Calidad. Confianza. Resultados.
              </p>
            </div>

            {/* Social & Copyright */}
            <div className="flex flex-col items-center md:items-end gap-6" data-id="element-36">
              <div className="text-center md:text-right" data-id="element-37">
                <p className="text-brand-muted mb-3" data-id="element-38">
                  Seguinos en Instagram y conocé nuestros últimos trabajos.
                </p>
                <a href="#" className="inline-flex items-center gap-2 text-brand-silver hover:text-brand-red transition-colors duration-300" data-id="element-39">
                  <Instagram className="w-5 h-5" data-id="element-40" />
                  <span data-id="element-41">@morello_detailing_</span>
                </a>
              </div>

              <div className="text-sm text-brand-muted/60" data-id="element-42">
                © 2026 Morello Detailing - Todos los derechos reservados.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}